<template>
	<div>
		<el-card style="margin-bottom: 20px;">
			<el-row :gutter="10">
				<el-col :span="3" style="line-height: 35px;">
					所属类别
				</el-col>
				<el-col :span="8">
					<el-select v-model="category" placeholder="请选择类别..." @change="showData()">
						<el-option v-for="(item,index) in options" :key="index" :label="item" :value="item"></el-option>
					</el-select>
				</el-col>
			</el-row>
		</el-card>

		<el-card>
			<el-row justify="end" type="flex">
				<el-button type="primary" style="width:150px" @click="add()">新增产品</el-button>
			</el-row>
			<el-row>
				<el-table :data="showData()" v-loading="loading">
					<el-table-column label="#" fixed type="index" align="center">
						<template slot-scope="scope">
							{{(pageIndex - 1)*pageSize + scope.$index + 1}}
						</template>
					</el-table-column>
					<el-table-column prop="name" label="产品名称"></el-table-column>
					<el-table-column prop="category" label="所属类别"></el-table-column>
					<el-table-column label="缩略图">
						<template slot-scope="scope">
							<img :src="scope.row.imgUrl" style="width:60px;height:40px" />
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right">
						<template slot-scope="scope">
							<el-button size="small" circle icon="el-icon-edit" style="margin-right:5px" type="primary" @click="edit(scope.row)"></el-button>
							<el-popconfirm title="确定要删除当前产品吗" @confirm="del(scope.row)">
								<el-button size="small" circle type="danger" icon="el-icon-delete" slot="reference"></el-button>
							</el-popconfirm>
							
						</template>
					</el-table-column>
				</el-table>
				<el-pagination background layout="total, sizes, prev,pager,next,jumper" :total="total" @size-change="sizeChange"
				 @current-change="currentChange"></el-pagination>
			</el-row>
		</el-card>

		<el-dialog title="添加/编辑产品" :visible.sync="showPro" :close-on-click-modal="false" center>
			<el-form :model="productModel" :inline="true">
				<el-row>
					<el-col :span="24">
						<el-form-item label="产品名称">
							<el-input v-model="productModel.name" style="width: 800px;"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="5">
					<el-col :span="24">
						<el-form-item label="所属分类">
							<el-select v-model="productModel.category">
								<el-option v-for="(item,index) in options" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="首页展示">
							<el-switch v-model="productModel.isShow" active-color="#509EFF" inactive-color="#DCDFE6"></el-switch>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="缩略图">
							<fileup @changed="getUpfile"><el-button>上传<i class="el-icon-plus el-icon--right"></i></el-button></fileup>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<img style="width:300px;height:150px" :src="productModel.imgUrl"/>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="产品说明">
							<editor style="width:800px" @content="contentchange" ref="edit"></editor>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="save()" type="primary" style="width:300px">保存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import tinymce from '../../../../components/tinymce-editor.vue'
	import upfile from '../upfile/index.vue'
	export default {
		data() {
			return {
				pageIndex: 1,
				pageSize: 10,
				total: 0,
				category: '',
				options: [],
				data: [],
				orginData: [],
				productModel: {
					id: '',
					category: '',
					name: '',
					url: '',
					imgUrl: '',
					isShow: '',
					content:''
				},
				showPro: false,
				editing: false,
				 loading:true 
			}
		},
		components:{
			editor:tinymce,
			fileup: upfile
		},
		methods: {
			loadData() {
				this.$http.get('product/GetProduct.do')
					.then(res => {
						this.data = res.data
						this.data.forEach(item => {
							if(item.imgUrl.indexOf('http') < 0){
								item.imgUrl = 'http://yigee.cn:81' + item.imgUrl.substring(2)
							}
						})
						this.total = this.data.length
						this.loading = false 
					})
					.catch(ex => {
						this.$message(ex.body)
					})
				this.$http.get('product/GetCategory.do')
					.then(res => {
						this.options = res.data
					})
					.catch(ex => {
						this.$message(ex.body)
					})
			},
			showCategory() {
				this.data = this.orginData
				this.data = this.data.filter(item => item.category == this.category)
			},
			sizeChange(e) {
				this.pageSize = e
			},
			currentChange(e) {
				this.pageIndex = e
			},
			showData() {
				if (this.category) {
					let tmp = this.data.filter(item => item.category == this.category)
					this.total = tmp.length
					return tmp.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize)
				} else {
					let tmp = this.data.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize)
					this.total = this.data.length
					return tmp
				}
			},
			upload(){
				this.$refs.thumb.click()
			},
			save() {
				if(this.editing){
					this.$http.post('product/UpdateProduct.do', {id: this.productModel.id, category: this.productModel.category,
					name:this.productModel.name, url:this.productModel.url, imgUrl: this.productModel.imgUrl, content:this.productModel.content,
					isShow:  this.productModel.isShow ? 1 : 0})
					.then(res=>{
						if(res.data.code == "1"){
							this.showPro=false
							this.$message("编辑产品成功")
							this.loadData()
						}
						else{
							this.showPro=false
							this.$message("编辑产品失败，请重试")
						}
					})
					.catch(ex=>{
						this.showPro=false
						this.$message(ex.body)
					})
				}
				else {
					this.$http.post('product/InsertProduct.do', {category: this.productModel.category,
					name:this.productModel.name, url:this.productModel.url, imgUrl:this.productModel.imgUrl, content:this.productModel.content,
					isShow:  this.productModel.isShow ? 1 : 0})
					.then(res=>{
						if(res.data.code == "1"){
							this.showPro=false
							this.$message("新增产品成功")
							this.loadData()
						}
						else{
							this.showPro=false
							this.$message("新增产品失败，请重试")
						}
					})
					.catch(ex=>{
						this.showPro=false
						this.$message(ex.body)
					})
				}
			},
			add() {
				this.showPro = true
				this.editing = false 
			},
			edit(val){
				this.editing = true 
				this.showPro = true 
				this.productModel = val 
				console.log(val.content)
				this.$nextTick(()=>{
					if(val.content)
						this.$refs.edit.clearContent(val.content)
					else 
						this.$refs.edit.clearContent('')
				})
				
			},
			setThumb(event){
				console.log(event.target.files)
			},
			del(val){
				this.$http.post('product/DelProduct.do', {id: val.id})
				.then(res=>{
					if(res.data.code == "1"){
						this.$message("删除产品成功")
						this.loadData()
					}
					else{
						this.$message("删除产品失败，请重试")
					}
				}
				)
				.catch(ex=>{
					this.$message(ex.body)
				})
			},
			contentchange(e){
				this.productModel.content = e 
				console.log(this.productModel.content)
			},
			getUpfile(file){
				this.productModel.imgUrl = file.url
			}
		},
		mounted(){
			this.loadData()
		}
	}
</script>

<style>
</style>
